import { Splide } from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import { Grid } from "@splidejs/splide-extension-grid";

document.addEventListener("DOMContentLoaded", function () {
  Splide.defaults = {
    type: "loop",
    perPage: 1,
    gap: "1rem",
    padding: "2rem",
    pagination: true,
    arrows: false,
    mediaQuery: "min",
    lazyLoad: false,
  };

  const logoCarouselElement = document.querySelector(".logo-carousel");
  if (logoCarouselElement) {
    new Splide(logoCarouselElement, {
      perPage: 2,
      gap: "2rem",
      fixedHeight: "80px",
      pagination: false,
      autoWidth: true,
      AutoScroll: {
        speed: 2,
      },
      breakpoints: {
        768: {
          gap: "10rem",
        },
      },
    }).mount({ AutoScroll });
  }

  const logoRevCarouselElement = document.querySelector(
    ".logo-carousel-reverse"
  );
  if (logoRevCarouselElement) {
    new Splide(logoRevCarouselElement, {
      perPage: 2,
      gap: "2rem",
      fixedHeight: "80px",
      pagination: false,
      autoWidth: true,
      direction: "rtl",
      AutoScroll: {
        speed: 2,
      },
      breakpoints: {
        768: { gap: "10rem" },
        1024: {
          destroy: true,
        },
      },
    }).mount({ AutoScroll });
  }

  const residentialCarouselElement = document.querySelector(
    ".residential-carousel"
  );
  if (residentialCarouselElement) {
    new Splide(residentialCarouselElement, {
      type: "slide",
      pagination: false,
      breakpoints: {
        768: {
          // Configuration for screens 768px and above
          grid: {
            rows: 3,
            cols: 3,
            gap: {
              row: "2rem",
              col: "2rem",
            },
          },
        },
        1024: {
          // Configuration for screens 1024px and above
          grid: {
            rows: 2,
            cols: 4,
            gap: {
              row: "2rem",
              col: "2rem",
            },
          },
        },
      },
    }).mount({ Grid });
  }

  const commercialCarouselElement = document.querySelector(
    ".commercial-carousel"
  );
  if (commercialCarouselElement) {
    new Splide(commercialCarouselElement, {
      type: "slide",
      pagination: false,
      breakpoints: {
        768: {
          // Configuration for screens 768px and above
          grid: {
            rows: 1,
            cols: 3,
            gap: {
              row: "2rem",
              col: "2rem",
            },
          },
        },
        1024: {
          // Configuration for screens 1024px and above
          grid: {
            rows: 1,
            cols: 3,
            gap: {
              row: "2rem",
              col: "2rem",
            },
          },
        },
      },
    }).mount({ Grid });
  }

  const commercialExpertiseElement = document.querySelector(
    ".commercial-expertise"
  );
  if (commercialExpertiseElement) {
    new Splide(commercialExpertiseElement, {
      pagination: true,
    }).mount();
  }

  const resFooterElement = document.querySelector(".rs-ft");
  if (resFooterElement) {
    new Splide(resFooterElement, {
      pagination: false,
      start: resCurrentSlide,
      breakpoints: {
        768: {
          perPage: 3,

          // Configuration for screens 768px and above
        },
        1024: {
          perPage: 5,

          // Configuration for screens 1024px and above
        },
      },
    }).mount({ Grid });
  }

  const commFooterElement = document.querySelector(".cm-ft");
  if (commFooterElement) {
    new Splide(commFooterElement, {
      type: "slide",
      pagination: false,
      start: comCurrentSlide,
      breakpoints: {
        768: {
          perPage: 3,

          // Configuration for screens 768px and above
        },
        1024: {
          perPage: 5,

          // Configuration for screens 1024px and above
        },
      },
    }).mount({ Grid });
  }

  const relProjectsElement = document.querySelector(".related-projects");
  if (relProjectsElement) {
    new Splide(relProjectsElement, {
      type: "slide",
      pagination: false,
      breakpoints: {
        768: {
          // Configuration for screens 768px and above
          grid: {
            rows: 1,
            cols: 3,
            gap: {
              row: "2rem",
              col: "2rem",
            },
          },
        },

        1024: {
          // Configuration for screens 1024px and above
          grid: {
            rows: 1,
            cols: 4,
            gap: {
              row: "2rem",
              col: "2rem",
            },
          },
        },
      },
    }).mount({ Grid });
  }

  const teamFooterElement = document.querySelector(".team-carousel");
  if (teamFooterElement) {
    new Splide(teamFooterElement, {
      type: "slide",
      pagination: false,
      breakpoints: {
        768: {
          // Configuration for screens 768px and above
          grid: {
            rows: 1,
            cols: 3,
            gap: {
              row: "2rem",
              col: "2rem",
            },
          },
        },

        1024: {
          // Configuration for screens 1024px and above
          grid: {
            rows: 1,
            cols: 4,
            gap: {
              row: "2rem",
              col: "2rem",
            },
          },
        },
      },
    }).mount({ Grid });
  }
});
